import {Component, Inject, Input, OnInit} from '@angular/core';
import {DOCUMENT} from '@angular/common';

@Component({
  selector: 'app-digitalizacion-contenido',
  templateUrl: './digitalizacion-contenido.component.html',
  styleUrls: ['./digitalizacion-contenido.component.scss']
})
export class DigitalizacionContenidoComponent implements OnInit {
    showSearch = true
    guardado = false
    @Input() GeneralSearchActive = false
  constructor( @Inject(DOCUMENT) private document: Document, ) { }

  ngOnInit(): void {
      this.document.location.href.split('/').forEach(l => {
          if ( l === 'registro-guardado') {
              this.guardado = true
          }
      })
  }
  open() {
  }
    activar(l: string) {
        this.guardado = false

        if ( l === 'guardado') {
            this.guardado = true
        }
    }

}
